export default __webpack_public_path__ + "static/media/snd_00028.1c71191d.mp4";